import { Page } from '@/core/architecture'

import { ConsoleMissionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMissions Page
 * Implemented as a practical sample.
 */
export const ConsoleMissions: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMissionsTemplate state={state} {...actions} />
}
